export const DEFAULT_SELECTED_OPTION = 'Stores';

export const RESPONSIVE_BREAKPOINTS = {
  buttonWidth: {
    base: '100%',
    sm: '150px',
    md: '180px',
  },
  dropdownMaxHeight: {
    base: '200px',
    md: '300px',
  },
  buttonPaddingX: {
    base: 8,
    sm: 16,
    md: 16,
  },
  fontSize: {
    base: '14px',
    md: '16px',
  },
} as const;
